var React = require('react');

function H (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Logo/H"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Logo/H","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("path",{"d":"M12.1807115,7 L1.48279318,7 L0,0 L14.58864,0 L21.7342087,0 L19.4237106,11.121751 L26.6027584,11.121751 L28.9132565,0 L37,0 L30.6048712,30 L22.5387572,30 L25.1174381,17.7701778 L17.9796492,17.7701778 L15.3597094,30 L7.29359531,30 L6.37427455,30 L4.8902695,23 L8.78097849,23 L9.84339505,18 L3.80827235,18 L2.33495402,11 L11.3307782,11 L12.1807115,7 Z","id":"H","fill":"#000000"}))]);
}

H.defaultProps = {"width":"37px","height":"30px","viewBox":"0 0 37 30","version":"1.1"};

module.exports = H;

H.default = H;
